import ShowInOpenseaLink from '../ShowInOpenseaLink.vue';

export default  {
  props: {
    tokenId: {
      type: Number,
      required: true,
    },
  },
  components:{
    ShowInOpenseaLink
  },
  mounted() {
    this.getBlockchainData();
  },
  computed: {
    priceInEther() {
      return this.web3Dapp.utils.fromWei(this.price, "ether");
    }
  },
  data() {
    return {
      collectionId: null,
      title: "Untitled",
      collection: null,
      withdrawOnBurn: false,
      tokenUri: "",
      contentUri: "",
      price: "0",
      message: "",
      pending: false,
      editionNumber: "",
      edition: "",
      editionLimit: "",
      metadata: "",
      claimable: false,
    };
  },
    methods: {
      httpUri(uri){
        return uri.replace('ipfs://', 'https://artburn.mypinata.cloud/ipfs/');
      },
      async enableEthereum(){
        
        const accounts =  await this.web3Client.eth.currentProvider.request({ method: 'eth_requestAccounts' });
        this.emitter.emit('ethereum-enabled',accounts[0]);
        return accounts[0];    
      },
      async claim() {
        
        let from;
        if(this.account === undefined || this.account != this.web3Client.eth.currentProvider.selectedAddress){
          from = await this.enableEthereum();
        }
        else{
          from = this.account;
        }

        //const accounts = await this.web3.eth.getAccounts();
        this.pending = true;
        await this.artburnClient.methods
          .claim(this.tokenId)
          .send({ from, value: this.price });
        this.pending = false;
        this.emitter.emit("claimed");
  
        this.getPrice();
      },
  
     
  
      async burn() {

        let from;
        if(this.account === undefined || this.account != this.web3Client.eth.currentProvider.selectedAddress){
          from = await this.enableEthereum();
        }
        else{
          from = this.account;
        }
       
        await this.artburnClient.methods.burn(this.tokenId).send({ from });
      },
  
      async getPrice() {
        this.price = await this.artburnDapp.methods
          .getTokenClaimPrice(this.tokenId)
          .call();
      },
      fetchMetadata() {

        fetch(this.httpUri(this.tokenUri))
          .then((response) => response.json())
          .then((json) => {
            this.metadata = json;
          })
          .catch((error) => console.error(error));
      },
      async getBlockchainData() {
        this.collectionId = await this.artburnDapp.methods
          .tokenCollection(this.tokenId)
          .call();
  
        this.collection = await this.artburnDapp.methods
          .collection(this.collectionId)
          .call();
  
        this.tokenUri = await this.artburnDapp.methods.tokenURI(this.tokenId).call();
  
        this.contentUri = await this.artburnDapp.methods
          .contentURI(this.tokenId)
          .call();
  
        this.withdrawOnBurn = await this.artburnDapp.methods
          .willWithdrawWhenBurned(this.tokenId)
          .call();
  
        this.price = await this.artburnDapp.methods
          .getTokenClaimPrice(this.tokenId)
          .call();
  
        this.editionNumber = await this.artburnDapp.methods
          .editionNumber(this.tokenId)
          .call();
  
        this.edition = await this.artburnDapp.methods
          .currentEdition(this.tokenId)
          .call();
  
        this.editionLimit = await this.artburnDapp.methods
          .maximumEdition(this.tokenId)
          .call();
  
        this.claimable = await this.artburnDapp.methods
          .isClaimable(this.tokenId)
          .call();
  
        this.fetchMetadata();
      }
    }
  }